import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";

const Adk5MinFactorTable = ({ params, report, onSortChange }) => {
    const rows = report.map((row, index) => (<Row params={params} row={row} key={index} />));

    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange} params={params} />
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default Adk5MinFactorTable;



// WEBPACK FOOTER //
// ./src/scenes/Adk5MinFactor/components/Table/index.js